import { combineReducers } from 'redux';

import UserReducer from './userReducer';
import OrganizationReducer from './organizationReducer';

export default combineReducers({
  user: UserReducer,
  organization: OrganizationReducer,
});
